import React from "react";
import { useDispatch } from "react-redux";
import { X as CloseIcon } from "react-feather";

import { useTypedSelector } from "../../../store/models/root.interface";
import { hideAttendeeInfo } from "../../../store/actions/attendees.actions";
import AttendeeInfoSidebar from "./AttendeeInfoSidebar";
import AttendeesSidebar from "./AttendeesSidebar";

const AttendeesSidebarRoot = () => {

  const dispatch = useDispatch();

  const attendeeId = useTypedSelector((state) => state.attendees.attendeeId);

  const close = () => {
    dispatch(hideAttendeeInfo());
  };

  return (
    <div className="sidebarWrapper">
      {attendeeId
        ? (
          <>
            <AttendeeInfoSidebar />
            <CloseIcon
              className="sidebarWrapper__icon nav-icon mt-2 mr-2 text-secondary"
              onClick={() => close()}
            />
          </>
        )
        : (<AttendeesSidebar />)}
    </div>
  );
};

export default AttendeesSidebarRoot;
